import {
	PAYOUT_REQUESTS_LIST_INITIATED,
	PAYOUT_REQUESTS_INITIATED,
	PAYOUT_REQUESTS_LOADED,
	PAYOUT_REQUESTS_FAILED,
	PAYOUT_REQUESTS_LIST_LOADED,
	PAYOUT_REQUESTS_COUNT_INITIATED,
	PAYOUT_REQUESTS_COUNT_LOADED,
	PAYOUT_REQUESTS_COUNT_FAILED,
	PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED,
	PAYOUT_MERCHANT_COUNT_LOADED,
	PAYOUT_MERCHANT_COUNT_FAILED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_INITIATED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_LOADED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_FAILED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_INITIATED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_LOADED,
	PAYOUT_MERCHANT_DEBIT_AND_LIEN_FAILED,
	MERCHANT_PAYOUT_LIST_INITIATED,
	MERCHANT_PAYOUT_LIST_LOADED,
	MERCHANT_PAYOUT_LIST_FAILED
	
} from "../actions/MerchantPayoutAction";

const initialState = {
	listdata: [],
	listDebitandLien: [],
	data: [],
	debitandlienCount: {
		debited_count: "0",
		debited_amount: "0",
		debited_total: "0",
		debited_charges: "0",
		debited_tax: "0",

		complaints_count: "0",
		complaints_amount: "0",
		complaints_total: "0",
		complaints_charges: "0",
		complaints_tax: "0",

		total_count: "0",
		total_amount: "0",
		total_total: "0",
		total_charges: "0",
		total_tax: "0",
	},
	payoutCount: {
		initiated_count: "0",
		initiated_amount: "0",
		initiated_total: "0",
		initiated_charges: "0",
		initiated_tax: "0",

		success_count: "0",
		success_amount: "0",
		success_total: "0",
		success_charges: "0",
		success_tax: "0",

		failure_count: "0",
		failure_amount: "0",
		failure_total: "0",
		failure_charges: "0",
		failure_tax: "0",

		inprogress_count: "0",
		inprogress_amount: "0",
		inprogress_total: "0",
		inprogress_charges: "0",
		inprogress_tax: "0",
	},
	merchantPayoutCount: {
		initiated_count: "0",
		initiated_amount: "0",
		initiated_total: "0",
		initiated_charges: "0",
		initiated_tax: "0",

		success_count: "0",
		success_amount: "0",
		success_total: "0",
		success_charges: "0",
		success_tax: "0",

		failure_count: "0",
		failure_amount: "0",
		failure_total: "0",
		failure_charges: "0",
		failure_tax: "0",

		inprogress_count: "0",
		inprogress_amount: "0",
		inprogress_total: "0",
		inprogress_charges: "0",
		inprogress_tax: "0",
	},
	pagination: {
		total: 0,
		page: 1,
		limit: 10,
		totalPages: 1,
		nextPage: null,
	},
	loading: false,
	error: null,
};

const MerchantPayoutAction = (state = initialState, action) => {
	switch (action.type) {
		case PAYOUT_REQUESTS_LIST_INITIATED:
			return {
				...state,
				data: {},
				loading: true,
				error: null,
			};
		case PAYOUT_REQUESTS_LIST_LOADED:
			return {
				...state,
				loading: false,
				data: {},
				listdata: action.payload.data,
				pagination: action.payload.pagination,
			};
		case PAYOUT_REQUESTS_INITIATED:
			return { ...state, loading: true, error: null };
		case PAYOUT_REQUESTS_LOADED:
			const updatedObj = Object.fromEntries(
				Object.entries(action.payload).map(([key, value]) => [
					key,
					value === null ? "" : value,
				])
			);
			return { ...state, loading: false, data: updatedObj };
		case PAYOUT_REQUESTS_COUNT_INITIATED:
			return { ...state };
		case PAYOUT_REQUESTS_COUNT_LOADED:
			return { ...state, payoutCount: action.payload };
		case PAYOUT_REQUESTS_COUNT_FAILED:
			return { ...state };
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_INITIATED:
			return { ...state };
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_LOADED:
			return { ...state, debitandlienCount: action.payload };
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_COUNT_FAILED:
			return { ...state };
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_INITIATED:
			return { ...state };
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_LOADED:
			return {
				...state,
				loading: false,
				data: {},
				listDebitandLien: action.payload.data,
				pagination: action.payload.pagination,
			};
		case PAYOUT_MERCHANT_DEBIT_AND_LIEN_FAILED:
			return { ...state };
		case PAYOUT_MERCHANT_REQUESTS_COUNT_INITIATED:
			return { ...state };
		case PAYOUT_MERCHANT_COUNT_LOADED:
			return { ...state, merchantPayoutCount: action.payload };
		case PAYOUT_MERCHANT_COUNT_FAILED:
			return { ...state };
		case MERCHANT_PAYOUT_LIST_INITIATED:
			return { ...state };
		case MERCHANT_PAYOUT_LIST_LOADED:
			return {
				...state,
				loading: false,
				data: {},
				listDebitandLien: action.payload.data,
				pagination: action.payload.pagination,
			};
		case MERCHANT_PAYOUT_LIST_FAILED:
			return { ...state };
		case PAYOUT_REQUESTS_FAILED:
			return { ...state, loading: false, error: action.payload };
		default:
			return state;
	}
};

export default MerchantPayoutAction;
